import MainScript from './main.js'
import DesktopView from './desktop/index.vue';

// let service = new services();
export default {
    name: 'MHome',
    mixins: [MainScript],
    data () {
        return {}
    },
  
    components: {
        
        //
        'component-desktop':DesktopView
    },
  
    methods: {},
    created: function(){}
}


// WEBPACK FOOTER //
// ./src/pages/Timeline/script.js